import React from "react";

import ToolBtn from "./ToolBtn";

import { Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type ToolBarProps = {
  onOcrSelected: (e: any) => void;
  onHandwritingSelected: (e: any) => void;
  onTablesSelected: (e: any) => void;
  onDragSelected: (e: any) => void;
  onSelectSelected: (e: any) => void;
  onZoomIn: (e: any) => void;
  onZoomOut: (e: any) => void;
  toolType: string;
  dragModeEnabled: boolean;
  toolbarFn: () => any;
};
export default class ToolBar extends React.Component<ToolBarProps, {}> {
  public render() {
    const {
      onDragSelected,
      onSelectSelected,
      onZoomIn,
      onZoomOut,
    } = this.props;
    return (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around",
          }}
        >
          <Row>
            {/* <Col style={{ marginBottom: "5px" }}>
              <div
                className="btn-group extract-data-tools"
                style={{ width: "50%" }}
              >
                {this.props.toolbarFn()}
              </div>
            </Col> */}
            <Col>
              <div
                className="btn-group document-tools"
                style={{ width: "50%" }}
              >
                <ToolBtn
                  selected={this.props.dragModeEnabled === false}
                  name="select-tool"
                  onClick={onSelectSelected}
                  text={"Select"}
                >
                  <FontAwesomeIcon icon="mouse-pointer" size="1x" />
                </ToolBtn>
                <ToolBtn
                  selected={this.props.dragModeEnabled === true}
                  name="drag-tool"
                  onClick={onDragSelected}
                  text={"Drag"}
                >
                  <FontAwesomeIcon icon="arrows-alt" size="1x" />
                </ToolBtn>
                <ToolBtn
                  selected={false}
                  name="zoom-out-tool"
                  onClick={onZoomOut}
                  text={"Zoom out"}
                >
                  <FontAwesomeIcon icon="search-minus" size="1x" />
                </ToolBtn>
                <ToolBtn
                  selected={false}
                  name="zoom-in-tool"
                  onClick={onZoomIn}
                  text={"Zoom In"}
                >
                  <FontAwesomeIcon icon="search-plus" size="1x" />
                </ToolBtn>
                {this.props.children}
              </div>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}
